import React from 'react'
import cx from 'classnames'
import './style'

const StyledBackground = () => (
    <div
        {...{
            className: cx(
                'StyledBackground',
            ),
        }}
    />
)

export default StyledBackground
